module.exports = __webpack_public_path__ + "static/speed-hero@2x-c682b4a56d4da862cf624ba30c38ecff.png";